import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild, Output } from '@angular/core';
import {
  ApplicationRouteURL,
  IKeyValueInterface
} from '../../shared/config';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { TwoFAService } from '../models/TwoFa.service';

@Component({
  selector: 'Wego-Popup-two-fa-selection',
  template: require('../views/two-fa-selection.html'),
  providers: [AuthService,TwoFAService]
})
export class TwoFASelectionPopupComponent implements OnInit {
  apiErrorMsg: string;
  errorModel: IKeyValueInterface[];
  errorMessage: string;
  bodyHTMLText: string;
  isLoading: boolean = false;
  selectedTwoFa: string = "EMAIL";
  TwoFa_method: string;

  constructor(
    public authService: AuthService,
    private router: Router,
    private TwoFAService: TwoFAService,
  ) { }

  ngOnInit() {
    this.TwoFa_method = this.authService.getTwoFaMethod();

    if (this.TwoFa_method == "ALL") {
      this.selectedTwoFa == "EMAIL"
    } else {
      this.selectedTwoFa = this.TwoFa_method;
    }
  }

  public NavigateTo() {
    if (this.selectedTwoFa == "GOOGLE") {
      this.router.navigate([ApplicationRouteURL.URL_TWO_FA_GOOGLE_SETUP]);
    } else {
      this.SendEmailOTP();
    }
  }

  public SendEmailOTP() {
    this.TwoFAService.SendEmailOTP()
      .subscribe(
        res => {
          if (res.data) {
            this.router.navigate([ApplicationRouteURL.URL_TWO_FA_EMAIL_OTP]);
          }
          else {
            this.errorModel = res.error;
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public Logout() {
    this.authService.Logout();
    this.router.navigate(['/']);
  }

  OnAcceptClick(action: number) {
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/twofa/components/two-fa-selection.ts